import React from "react"
import { Jumbotron } from "react-bootstrap"

export default ({ title, children }) => (

  
  <div className="jumbotron page-header">
    <div className="container">
      {/* <h1 className="display-32">Let's talk about your Organization</h1> */}
      <h1>
        {title}&nbsp;<span>{children}</span>&nbsp;
      </h1>
      {/* <h2 className="display-32">
    Get key insights today.{' '}
      <span style={{ color: '#007bff' }}>
        Focus on what matters.
      </span>
    </h2> */}
    </div>
  </div>
)
/*   <Jumbotron className="bg-none pt-4 mb-5 pb-0">
    <h1>
      {title}&nbsp;<span>{children}</span>&nbsp;
    </h1>
  </Jumbotron> */
